<div class="service-conflict-dialog">
  <div class="service-conflict-dialog-header" mat-dialog-title>
    <div class="headline m-0" fxLayoutAlign="start center">
      <h2 class="m-0">Service Conflict Detail</h2>
    </div>
    <button
      type="button"
      (click)="onCloseModal(dialogRef)"
      mat-icon-button
      class="text-secondary service-conflict-close"
      matTooltip="Close"
    >
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>
  <mat-divider class="text-border"></mat-divider>
  <mat-dialog-content class="service-conflict-dialog-content">
    <vex-pre-deployment
      class="service-conflict-detail"
      [postingBlueprint]="postingBlueprint"
      [conflictContext]="conflictContext"
      (onClose)="onClose(dialogRef)"
    ></vex-pre-deployment>
  </mat-dialog-content>
</div>
